import {useEffect, useState} from 'react'
import {Autocomplete, Text} from '../../1elements'
import ApiService from '../../../common/ApiCalls'

const ServiceSearch = ({service, onServiceChange, selectedServiceTypeId, disabled}) => {
    const [options,setOptions] = useState([])

    const [searchInput, setSearchInput] = useState('')
    const onChangeTextField = (e) => {
        setSearchInput(e.target.value)
    }

    const searchService = async () => {
        const data = {
            name: searchInput,
            typeId: selectedServiceTypeId
        }
        const searchResult = await ApiService().getServiceByNameAndType(data)
        setOptions(searchResult)
    }

    useEffect(()=>{
        setOptions([])
    }, [selectedServiceTypeId])

    useEffect(()=>{
        if(selectedServiceTypeId){
            searchService()
        }
    // XXX Fix this in the future
    // eslint-disable-next-line
    }, [searchInput])

    return (
        <div>
            <Text type={'fieldLabel'}>Service Name</Text>
            <Autocomplete value={service} onChangeTextField={onChangeTextField}
                          options={options} onChangeAutocomplete={onServiceChange}
                          optionLabel={'name'} disabled={disabled} sx={searchFieldSx}/>
        </div>
    )
}

export default ServiceSearch

const searchFieldSx = {
    padding: 0,
    maxWidth: '400px',
    '& .MuiInputBase-root': {
        padding: 0
    },
    '& .MuiAutocomplete-inputRoot': {
        maxHeight: '29px'
    },
    '& .MuiInputBase-input': {
        height: '10px'
    }
}
